export function anyErrors(errors: Record<string, Array<string>>) {
	return Object.values(errors).reduce((memo, fieldErrors) => {
		memo = memo || fieldErrors.length > 0;
		return memo;
	}, false);
}
